export default "__VITE_ASSET__ea520007__"